<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" label="运营商" :label-width="60">
				<Select filterable clearable style="width: 120px;" v-model="formInline.OperatorId">
					<Option v-bind:key="item.Id" v-for="(item) in OperatorList" :value="item.Id">{{item.Name}}</Option>
					<!-- <span slot="prepend">联系电话</span> -->
				</Select>
			</FormItem>
			<FormItem prop="trackName" label="充电站" :label-width="60">
				<Select filterable placeholder="站点列表" style="width: 120px;" v-model="formInline.StationId">
					<Option :value=0>全部</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName" label="设备编号" :label-width="70">
				<Input type="text" style="width: 120px;" v-model="formInline.EquipmentNo" placeholder="设备编号" />
			</FormItem>
			<FormItem prop="trackName" label="设备序列号" :label-width="85">
				<Input type="text" style="width: 120px;" v-model="formInline.EquipmentSerialNo" placeholder="设备序列号" />
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
		</Form>
		<!-- <Table :columns="columns1" :data="data1" :height="tableHeight" size="small">
			<MyPage slot="footer" ref="sonPage" :param="pageParam" :url="getOfflineLogUrl" @listData='getDeviceData'>
			</MyPage>
		</Table> -->
		<PageTable ref="tableObj" :columns="columns1" :tableHeight="tableHeight" :url="getOfflineLogUrl" :queryParam="pageParam"></PageTable>
		<!-- <Modal ref="ChargingCurvesModel" width="70%" v-model="modalView" :title="modal.Title">
			<div id="ChargingCurves" style="width:100%;height:300px;"> </div>
			<div slot="footer">
				<Button type="success" size="large" @click="show('closeModal')">确定</Button>
			</div>
		</Modal> -->
		<!-- <echartModal ref="echartModal" curvesName="realChargingCurves"></echartModal> -->
	</div>
</template>

<script>
	// import dateFormat from '../../../../public/js/comm.js'
	// import echartModal from '../../public/CurvesTemplate/ChargingOrderEchart.vue'
	import PageTable from '../../public/PageTable/PageTable.vue';
	// import Qs from 'qs'
	// import expandRow from './ChargingInfoExpand.vue';
	// import echart from '../../../js/echarts_hot.js'
	import {
		mapState,
		// mapGetters,
		// mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		components: {
			// echartModal,
			PageTable
		},
		data() {
			return {
				getOfflineLogUrl: webapi.base_api_url + '/Operations/GetOfflineLogRecord',
				Control: {},
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				tableHeight: "650",
				modal: {
					Title: "设备信息添加",
					type: "addDevice"
				},
				modalView: false,
				// BreadcrumbList: ['场站监控', '>>', '设备状态'],
				formInline: {
					StationId: 0,
					EquipmentNo: '',
					EquipmentSerialNo: '',
				},
				//table标题数据
				columns1: [
					// {
					// 	type: 'expand',
					// 	width: 50,
					// 	// render: (h, params) => {
					// 	// 	return h(expandRow, {
					// 	// 		props: {
					// 	// 			row: params.row
					// 	// 		}
					// 	// 	})
					// 	// }
					// },
					{
						title: 'ID',
						key: 'ConnectorId',
						width: 80,
					},
					{
						title: '充电枪编号',
						key: 'ConnectorNo',
						minWidth: 100,
					},
					{
						title: '设备序列号',
						key: 'EquipmentSerialNo',
						minWidth: 105,
					},
					{
						title: '事件状态',
						key: 'EventType',
						minWidth: 100,
						render: (h, params) => {
							return h('Tag', {
									props: {
										color: params.row.EventType == 1 ? 'warning' : 'success'
									},
									style: {
										width: '60px',
										textAlign: 'center'
									}
								},
								params.row.EventTypeDesc
							);
						}
					},
					{
						title: '发生时间',
						key: 'OccurrenceTime',
						width: 105,
					},
					{
						title: '异常变位状态',
						key: 'OccurrenceStatusDesc',
						minWidth: 115,
					},
					{
						title: '恢复时间',
						key: 'RecoveryTime',
						width: 105,
					},
					{
						title: '恢复变位状态',
						key: 'RecoveryStatusDesc',
						minWidth: 115,
					},
					{
						title: '离线时长',
						key: 'OfflineDurationDesc',
						align: 'right',
						minWidth: 90,
					},
					{
						title: '设备型号',
						key: 'EquipmentModel',
						minWidth: 100,
					},
					{
						title: '设备类型',
						key: 'EquipmentType',
						minWidth: 100,
						render: (h, params) => {
							return h('div',
								params.row.EquipmentTypeDesc
							);
						}
					},
					// {
					// 	title: '额定功率',
					// 	key: 'RatedPower'
					// },
					{
						title: '站点名称',
						key: 'StationName',
						minWidth: 100,
					},


					// , {
					// 	title: '设备编号',
					// 	key: 'EquipmentNo',
					// }, {
					// 	title: '设备名称',
					// 	key: 'EquipmentName',
					// },
					// {
					// 	title: '枪名称',
					// 	key: 'ConnectorName'
					// },
					// {
					// 	title: '设备类型',
					// 	key: 'EquipmentType',
					// 	render: (h, params) => {
					// 		return h('div',
					// 			params.row.EquipmentTypeDesc
					// 		);
					// 	}
					// },
					// {
					// 	title: '枪类型',
					// 	key: 'ConnectorType',
					// 	render: (h, params) => {
					// 		return h('div',
					// 			params.row.ConnectorTypeDesc
					// 		);
					// 	}
					// },
					// {
					// 	title: '操作',
					// 	key: 'action',
					// 	width: 200,
					// 	align: 'center',
					// 	render: (h, params) => {
					// 		console.log(this.Control);
					// 		let MyButton = [];
					// 		if (this.hasWidgets('stopCharge')) {
					// 			MyButton.push(
					// 				h('Button', {
					// 					props: {
					// 						type: 'error',
					// 						size: 'small'
					// 					},
					// 					style: {
					// 						marginRight: '5px'
					// 					},
					// 					on: {
					// 						click: () => {
					// 							this.$Modal.confirm({
					// 								title: '枪：' + params.row.ConnectorNo +
					// 									' 停止充电？',
					// 								okText: '取消',
					// 								cancelText: '确定',
					// 								onCancel: () => {
					// 									this.stopCharging(params.row
					// 										.ConnectorNo);
					// 								}
					// 							});
					// 						}
					// 					}
					// 				}, '停止充电')
					// 			)
					// 		}
					// 		if (this.hasWidgets('chargeCurves')) {
					// 			MyButton.push(
					// 				h('Button', {
					// 					props: {
					// 						type: 'primary',
					// 						size: 'small'
					// 					},
					// 					style: {
					// 						marginRight: '5px'
					// 					},
					// 					on: {
					// 						click: () => {
					// 							this.show("ChargingCurves", params.row.OrderNo)
					// 						}
					// 					}
					// 				}, '充电曲线')
					// 			)
					// 		}
					// 		return h('div', MyButton);
					// 	}
					// }
				],
				data1: [],

				//图标实例
				Myecharts: '',
				//图表数据
				// lineEchart: {
				// 	legend_data: ['电压曲线', '电流曲线', 'SOC曲线', '枪温度曲线'],
				// 	seriesData: [{
				// 			name: '电压曲线',
				// 			type: 'line',
				// 			stack: '分类1',
				// 			data: [0, 0, 0, 0, 0, 0, 0]
				// 		},
				// 		{
				// 			name: '电流曲线',
				// 			type: 'line',
				// 			stack: '分类2',
				// 			data: [0, 0, 0, 0, 0, 0, 0]
				// 		},
				// 		{
				// 			name: 'SOC曲线',
				// 			type: 'line',
				// 			stack: '分类3',
				// 			data: [0, 0, 0, 0, 0, 0, 0]
				// 		},
				// 		{
				// 			name: '枪温度曲线',
				// 			type: 'line',
				// 			stack: '分类4',
				// 			data: [0, 0, 0, 0, 0, 0, 0]
				// 		}
				// 	],
				// 	style: {
				// 		color: "black"
				// 	},
				// 	TimePoins: [1, 2, 3, 4, 5, 6, 7]
				// },
				timer: ''
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 160;
			_this.getTableHeight();
			window.addEventListener('resize', _this.getTableHeight)
			//window.addEventListener('resize', echart.resizeEchart(null))
		},
		activated() {
			// let col = this.$store.state.UserButton.find(item => window.location.href.indexOf(item.path) > 0);
			// this.Control = col.control
			// console.log(col.control);
			// this.timer = setInterval(this.handleSubmit, 30000);
		},
		deactivated() {
			// if (this.timer) {
			// 	clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			// }
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
			//window.removeEventListener('resize', echart.resizeEchart(null))
		},
		mounted() {
			const _this = this
			_this.handleSubmit();
		},
		beforeDestroy() {},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = _this.formInline;
				return param
			},

			//直接选属性
			...mapState({
				StationList: 'Stations',
				OperatorList: 'typeList',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//操作
			// show: function(type, OrderNo) {
			// 	switch (type) {
			// 		case "ChargingCurves":
			// 			this.modal.type = "ChargingCurves";
			// 			this.modal.Title = "充电曲线";
			// 			//this.modalView = true;
			// 			this.$refs.echartModal.show('view', OrderNo)
			// 			//this.getChargingCurves(OrderNo);
			// 			break;
			// 		case "update":
			// 			this.modal.type = "update";
			// 			this.modal.Title = "设备信息跟新";
			// 			this.getUpdateMessage(EquipmentNo);
			// 			this.modalView = true;
			// 			break;
			// 		case "closeModal":
			// 			echart.disposeEchart("ChargingCurves")
			// 			this.modalView = false;
			// 			break;
			// 	}
			// },
			// stopCharging: function(ConnectorNo) {
			// 	const _this = this
			// 	_this.$axios.post(webapi.base_api_url + "/Archives/StopCharge", {
			// 		ConnectorNo: ConnectorNo
			// 	}, {
			// 	}).then(res => {
			// 		console.log("停止充电")
			// 		console.log(res.data)
			// 		if (res.data.Code == 0) {
			// 			_this.$Message.info(ConnectorNo + '停止充电成功');
			// 			_this.handleSubmit()
			// 		} else {
			// 			this.$Message.success(res.data.Msg + "---" + res.data.Data);
			// 		}
			// 	})
			// },
			getDeviceData: function(data) {
				console.log("分页ChargingInfo")
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.tableObj.getData();
				// const _this = this;
				// let parms = {
				// 	StationId: _this.formInline.SelectStation
				// }
				// _this.$axios.post(webapi.base_api_url + "/Operations/GetChargingInfo", parms, {
				// }).then(res => {
				// 	console.log("res")
				// 	console.log(res.data)
				// 	if (res.data.Code == 0) {
				// 		_this.data1 = res.data.Data.ChargeingInfos;
				// 	}
				// })
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 160 - (window.innerWidth < 1086 ? 60 : 0);
			},
			// getChargingCurves: function(OrderNo) {
			// 	const _this = this
			// 	console.log(OrderNo)
			// 	let parms = {
			// 		OrderNo: OrderNo,
			// 	};
			// 	_this.$axios.post(webapi.base_api_url + "/Operations/GetChargingCurves", parms, {
			// 	}).then(res => {
			// 		console.log("实时充电-充电曲线res")
			// 		console.log(res.data)
			// 		if (res.data.Code == 0) {
			// 			let MyTimePoins = []
			// 			res.data.Data.Curves.ReportTime.forEach(function(time) {
			// 				//MyTimePoins.push(time.split(" ")[0])
			// 				MyTimePoins.push(time)
			// 			})
			// 			_this.lineEchart.TimePoins = MyTimePoins;
			// 			_this.lineEchart.seriesData[0].data = res.data.Data.Curves.VoltageCurve;
			// 			_this.lineEchart.seriesData[1].data = res.data.Data.Curves.CurrentCurve;
			// 			_this.lineEchart.seriesData[2].data = res.data.Data.Curves.SocCurve;
			// 			_this.lineEchart.seriesData[3].data = res.data.Data.Curves.TempConnectorCurve;
			// 			echart.initLinechart3("ChargingCurves", _this.lineEchart)
			// 		}
			// 	})
			// }
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>